export default __webpack_public_path__ + "static/media/audio.f232309b.svg";